@let pc = productCollection();
@let cms = cmsSearchResults();
@let navIndex = keyboardNavigationIndex();
@if (pc || cms) {
  <div #searchResults class="search-results">
    <div class="container" >
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        class="close" (click)="onAfterClicked()"
        >
        <path d="M18 6L6 18" stroke="#A49F9B" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 6L18 18" stroke="#A49F9B" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      @if (pc?.size || cms?.length) {
        <div class="row items">
          @if (pc) {
            @for (product of pc; track product; let i = $index) {
              <div [class.active]="navIndex == i" class="col-xs-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 item"
                (click)="onClickProduct($event, product)"
                >
                <gea-shop-product-item [product]="product" [scope]="'search'" class="index-{{ i }}"/>
              </div>
            }
          }
          @if (cms) {
            @for (item of cms; track item; let j = $index) {
              <div [class.active]="navIndex == (pc ? pc.size + j : -1)" (click)="onClickCmsItem(item)"
                class="col-xs-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 item"
                >
                <a class="cms-item" href="{{ item.url }}">
                  @if (getCmsImageSrc(item)) {
                    <img src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      [alt]="item.title"
                      [style.background-image]="
                        'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(\'' + getCmsImageSrc(item) + '\')'
                      "/>
                  } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180.119 139.794">
                      <g paint-order="fill markers stroke" transform="translate(-13.59 -66.639)">
                        <path fill="#fff" d="m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937h152.374z" opacity=".675"/>
                        <circle cx="58.217" cy="108.555" r="11.773" fill="#fff" opacity=".675"/>
                        <path fill="none" d="M26.111 77.634h152.614v116.099H26.111z"/>
                      </g>
                    </svg>
                  }
                  <div class="content">
                    <h5 class="title" [ngbTooltip]="item.title.length >= 31 ? item.title : undefined" placement="auto" container="div.item">{{ item.title | shortenText:31 }}</h5>
                    <span class="link">Beitrag lesen</span>
                  </div>
                </a>
              </div>
            }
          }
        </div>
      } @else {
        <div class="container">
          <p>Zu deiner Suchanfrage konnten keine Ergebnisse gefunden werden.</p>
        </div>
      }
    </div>
  </div>
}


